/* eslint-disable import/prefer-default-export */
export const DEFAULT_SETTLEMENT_AGENT = "Not Yet Chosen By Borrower";
